import { isEmpty } from '@ember/utils';

export const TYPE_DOMAIN = 'domain';
export const TYPE_EMAIL_START = 'emailStart';
export const TYPE_DOMAIN_START = 'domainStart';

// The regex isn't really comprehensive, but that's intentional.  We don't need
// to match exact URLs here, we just need to make sure that it looks reasonably
// close to a valid search string.

// It will match strings like:

// @gmail.com
// @gmail.co.uk
// @google-email.com
// @google
// @google-
// @google*
//
// (google* is not a valid URL but it's a valid search term). It won't match:

// @.co.uk
// @@google
// @google!!

// capturing groups are matching the 1) domain name ("@gmail"), 2) TLD (".co.uk")
const DOMAIN_PATTERN = /^@([\w-*]+)(\.[\w-*]+(?:\.[\w-*]+)?)?$/;

function splitIntoParts(term) {
  if (term.includes('@')) {
    let index = term.indexOf('@');
    return [term.slice(0, index), term.slice(index)];
  } else {
    return [term];
  }
}

export default function buildEmailSearchOptions(term) {
  if (typeof term !== 'string' || isEmpty(term.trim())) {
    return [];
  }

  let emailStart = {
    id: TYPE_EMAIL_START,
    label: `Search for emails that start with <code>${term}</code>`,
  };

  let domainMatch = {
    id: TYPE_DOMAIN,
    label: `Search for <code>${term.includes('@') ? term : `@${term}`}</code> domain`,
  };

  let domainStart = {
    id: TYPE_DOMAIN_START,
    label: `Search for domains that start with <code>${term.includes('@') ? term : `@${term}`}</code>`,
  };

  let [id, domain] = splitIntoParts(term);

  if (id && id !== '*') {
    if (domain) {
      return [];
    }

    if (id.includes('+')) {
      // When the term includes +, it's likely not going to match a domain, so
      // we suggest only start of email.
      return [emailStart];
    } else {
      return [emailStart, domainStart];
    }
  }

  let match = domain.match(DOMAIN_PATTERN);

  if (match) {
    let [, name, tld] = match;

    // If we have the name and the TLD both, we can suggest an exact domain
    // match, otherwise we suggest only start of domain.
    //
    // For example:
    //
    // - for @gmail, we suggest "domains starting with @gmail"
    //
    // - for @gmail.com, we suggest "domains starting with @gmail.com" and
    // "@gmail.com domain", the exact match

    if (name && tld) {
      return [domainMatch, domainStart];
    } else {
      return [domainStart];
    }
  }

  return [];
}
